import { keyframes } from '@emotion/react'

const cardBackgroundColor = '#222222'
const cardBorder = '1px solid #999999'
const cardBorderRadius = '32px'

const typography = (w = 1, h = 1) => {
  const scale = Math.min(w, h)
  const font = 0.5 * scale + 'rem'
  return {
    fontSize: font,
    textTransform: 'uppercase'
  }
}
const icon = (w = 1, h = 1) => {
  const scale = Math.min(w, h)
  const percent = 70 + ((scale - 1) / 11) * 100

  return {
    width: percent + '%',
    height: percent + '%',
    objectFit: 'contain'
  }
}

const widgetStyles = (theme = {}, status) => {
  const paletteColor = theme.palette[status] || theme.palette.primary
  const main = paletteColor.main
  const normalMode = status === 'primary' || status === null || status === undefined

  const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    return `rgba(${r},${g},${b},${alpha})`
  }

  const rgba = {
    low: hexToRgba(main, 0.2),
    mid: hexToRgba(main, 0.55),
    high: hexToRgba(main, 0.7),
    solid: hexToRgba(main, 1)
  }

  const incidenceBlink = keyframes({
    '0%': {
      boxShadow: `0 0 0 1px ${rgba.low}, 0 0 10px ${rgba.low}`,
      borderColor: rgba.mid,
      filter: `drop-shadow(0 0 2px ${rgba.low}) drop-shadow(0 0 10px ${rgba.low})`
    },
    '50%': {
      boxShadow: `0 0 0 2px ${rgba.mid}, 0 0 26px ${rgba.high}`,
      borderColor: rgba.solid,
      filter: `drop-shadow(0 0 3px ${rgba.mid}) drop-shadow(0 0 18px ${rgba.high})`
    },
    '100%': {
      boxShadow: `0 0 0 1px ${rgba.low}, 0 0 10px ${rgba.low}`,
      borderColor: rgba.mid,
      filter: `drop-shadow(0 0 2px ${rgba.low}) drop-shadow(0 0 10px ${rgba.low})`
    }
  })

  const iconSx = {

  }

  return {
    basePaper: {
      height: '100%',
      padding: '1rem',
      borderRadius: '20px',
      backgroundColor: 'rgba(32, 33, 36, 0.8)',
      backdropFilter: 'blur(20px)',
      border: !normalMode ? '1px solid ' + rgba.mid : '1px solid rgba(255, 255, 255, 0.08)',
      outline: 'none',
      boxShadow: !normalMode ? `0 0 0 1px ${rgba.mid}, 0 0 18px ${rgba.high}` : '0 4px 20px rgba(0, 0, 0, 0.2)',
      transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',

      animation: !normalMode ? `${incidenceBlink} 1.1s infinite` : 'none'
    },
    basePaperClickable: {
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: !normalMode
          ? `0 0 0 1px ${rgba.mid}, 0 0 22px ${rgba.high}`
          : '0 12px 28px rgba(0, 0, 0, 0.3)',
        border: !normalMode ? '1px solid ' + rgba.solid : '1px solid rgba(255, 255, 255, 0.2)'
      },
      '&:active': {
        transform: 'scale(0.98)',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)'
      }
    },
    logo: {
      width: '2.3rem',
      height: '2.3rem',
      backgroundColor: theme.palette.background.color_212121,
      borderRadius: '0.3rem',
      outline: '1px solid ' + theme.palette.divider,
      color: main,
      animation: status ? `${incidenceBlink} 1.1s infinite` : 'none'
    },
    card: {
      height: '100%',
      padding: '3% 10%',
      backgroundColor: cardBackgroundColor,
      border: cardBorder,
      borderRadius: cardBorderRadius
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.57,
      color: '#999999',
      textTransform: 'uppercase'
    },

    iconSx

  }
}

export { widgetStyles, typography, icon }
